// Use the server's current-organization entitlements; do not infer access from
// a client-selected plan or preset. Count and subscription gates are separate.
export function isChatbotTypeLocked(
  type: { id: string; underlyingType?: string },
  entitlements?: { allBotTypesAllowed: boolean; allowedBotTypes: string[] },
): boolean {
  if (!entitlements || entitlements.allBotTypesAllowed) return false;
  return !entitlements.allowedBotTypes.includes(type.underlyingType ?? type.id);
}
